<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div class="container-fluid d-flex flex-wrap justify-content-between text-center container-p-x pb-3">
      <div class="pt-3">
        <span class="footer-text" style="color:#ddd;font-size:12px;">Copyright © 2022 By 安岳县青少年校外活动中心 Industrial Co., Ltd. All rights Reserved.</span>
      </div>
      <div>
        <div class="pt-3">
          <div v-if="network">
            <div class="floatLeft"><i style="color: #02BC77;font-size:16px;padding-top:3px;" class="ion ion-ios-cellular"></i></div>
            <div class="floatLeft"><span style="margin-left:6px;font-size:12px;color: #02BC77;">网络正常</span></div>
            <div class="floatClear"></div>
          </div>
          <div v-if="!network">
            <div class="floatLeft"><i style="color: rgba(24, 28, 33, 0.5);font-size:16px;padding-top:3px;" class="ion ion-ios-cellular"></i></div>
            <div class="floatLeft"><span style="margin-left:6px;font-size:12px;">网络已断开...</span></div>
            <div class="floatClear"></div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'app-layout-footer',
  data () {
    return {
      network: true
    }
  },
  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    }
  },
  mounted () {
    // 检测断网
    window.addEventListener('offline', () => {
      this.network = false
    })
    window.addEventListener('online', () => {
      this.network = true
    })
  }
}
</script>
